<template>
  <quill-editor
    ref="quill"
    v-bind="$attrs"
    class="quill-editor"
    :options="editorOption"
    :name="name"
    :content="value"
    :disabled="disabledInternal"
    @change="$emit('input', $event.html)"
    @drop.native="onDrop($event)"
  />
</template>

<script>

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { uniqueId } from 'lodash'
import { HelperUtils } from '@/shared/util/helper-utils'

export default {
    name: 'VtRichTextEditor',
    components: {
        quillEditor
    },
    props: {
        value: {
            required: true,
            validator: (prop) => {
                return typeof prop === 'string' || prop === null
            }
        },
        disabled: { type: Boolean, required: false, default: false },
        autofocus: { type: Boolean, required: false, default: false },
        allowImages: { type: Boolean, default: true },
        allowToolbar: { type: Boolean, default: true },
        name: { type: String, default: () => uniqueId('richTextEditor') }
    },
    data() {
        return {
            editorOption: {
                modules: {
                    toolbar: [
                        [{ 'size': ['small', false, 'large'] }],
                        ['bold', 'italic', 'underline'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['link', 'image']
                    ],
                    history: {
                        delay: 1000,
                        maxStack: 50,
                        userOnly: false
                    }
                },
                placeholder: ''
            },
            disabledInternal: this.disabled
        }
    },
    watch: {
        disabled: function(newVal) {
            this.disabledInternal = newVal
        }
    },
    beforeMount() {
        if (!this.allowImages) {
            let toolbarWithoutImage = []
            this.editorOption.modules.toolbar.forEach(toolbarGroup => {
                const toolbarGroupWithoutImage = toolbarGroup.filter(groupItem => groupItem !== 'image')
                toolbarWithoutImage.push(toolbarGroupWithoutImage)
            })
            this.editorOption.modules.toolbar = toolbarWithoutImage
        }
        if (!this.allowToolbar) {
            this.editorOption.modules.toolbar = []
        }
    },
    mounted() {
        if (!this.disabledInternal && this.autofocus) {
            this.focus()
        }
    },
    methods: {
        onDrop(event) {
            if (!this.allowImages) event.preventDefault()
        },
        focus() {
            if (this.$refs.quill) {
                const editor = this.$refs.quill.$refs.editor.firstElementChild
                if (!this.disabledInternal) {
                    const childElements = editor.childElementCount
                    this.$_moveQuillEditorCaretToEnd(this.$refs.quill.quill, this.value?.length)
                    document.getSelection().collapse(editor, childElements)
                }
            }
        },
        insertTextAtCaretPosition(text) {
            HelperUtils.insertTextAtCaretPosition(this.$refs.quill.quill, text)
        },
        makeNonEditable() {
            if (this.$refs.quill) {
                this.disabledInternal = true
                this.$eventHub.$emit('focus-searcherModule')
            }
        }
    }
}

</script>

<style lang="scss">
  .quill-editor .ql-editor p {
    margin-bottom: 1rem;
  }

  .quill-editor .ql-active {
      background-color: vt-color(alt-primary) !important;
      border-radius: 3px;
  }

  .quill-editor .ql-active svg path,
  .quill-editor .ql-active svg line {
     stroke: vt-color(white-light) !important;
  }

  .quill-editor .ql-active svg rect {
     fill: vt-color(white-light) !important;
  }

  .quill-editor .ql-formats button {
      margin: 2px;
  }
  .ag-theme-balham .ag-cell {
      align-items: normal;
    }
</style>
